<template>
  <div class="instant-quote-generated-quote--container">
    <InstantQuotePriceAndSchedule :current-quote="instantQuote.currentQuote" />
    <div
      v-if="!instantQuote.currentQuote.customer_accepted_at"
      class="instant-quote-generated-quote--pending-buttons"
      test-id="pending-buttons"
    >
      <LsButton
        text="approve work"
        track-id="instant_quote_generated_quote-approve_work"
        test-id="approve_work"
        :loading="isUpdatingLocal"
        @click="acceptQuote"
      />
      <LsButton
        class="instant-quote-generated-quote--turn-down"
        bg-color="primary-light"
        text-color="primary"
        text="turn down"
        track-id="instant_quote_generated_quote-turn_down"
        test-id="turn_down"
        @click="declineQuote"
      />
    </div>
    <InstantQuoteAuthorized
      v-else
      test-id="authorized"
      :date-authorized="instantQuote.currentQuote.customer_accepted_at"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import VueTypes from 'vue-types';
import { INSTANT_QUOTE__ACCEPT_QUOTE, INSTANT_QUOTE__RESET_QUOTE } from '@/store/types';
import { LsButton } from '@/components/common';
import { lsModalService } from 'ls-vue-common';
import { InstantQuoteTurnDownModal } from '@/modals/';
import InstantQuotePriceAndSchedule from './InstantQuotePriceAndSchedule.vue';
import InstantQuoteAuthorized from './InstantQuoteAuthorized.vue';

export default {
  name: 'InstantQuoteFormGeneratedQuote',
  components: { LsButton, InstantQuotePriceAndSchedule, InstantQuoteAuthorized },
  props: {
    //eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.string.isRequired,
  },
  data() {
    return {
      isUpdatingLocal: false,
    };
  },
  computed: {
    ...mapState(['instantQuote']),
  },
  methods: {
    ...mapActions([INSTANT_QUOTE__ACCEPT_QUOTE, INSTANT_QUOTE__RESET_QUOTE]),
    async acceptQuote() {
      this.isUpdatingLocal = true;
      await this[INSTANT_QUOTE__ACCEPT_QUOTE]({
        property_id: this.property_id,
        onSuccess: this.onSuccess,
      });
      this.isUpdatingLocal = false;
    },
    onSuccess() {
      this.INSTANT_QUOTE__RESET_QUOTE();
      this.$router.push({
        name: 'services',
      });
    },
    declineQuote() {
      lsModalService.open({
        parent: this,
        component: InstantQuoteTurnDownModal,
        props: {
          property_id: this.property_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.instant-quote-generated-quote--container {
  padding-top: 20px;
  border-top: 1px solid $primary-light;
}

.instant-quote-generated-quote--pending-buttons {
  padding-top: 20px;
}

.instant-quote-generated-quote--turn-down {
  margin-left: 10px;
  @media (max-width: $mobile-max-width) {
    margin-left: 0;
    margin-top: 10px;
  }
}

.themed-app {
  .instant-quote-generated-quote--container {
    border-top-color: $theme-color-primary-light;
  }
}
</style>
